import { useState } from "react";
import styles from "./ResultsHeader.module.css";
import SaveContactsModal from "components/Modals/SaveContactsModal";
import resultsBoxStyles from "../ResultsBox.module.css";

const ResultsHeader = ({
    results,
    contacts,
    displayedContacts,
    selectedContacts,
    onSelectOne,
    onSelectAll,
    onSelectPage, 
    onClearSelected,
    setIsExportModalVisible,
    handleExport
}) => {

    const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
    // Compute whether all contacts are selected
    const selectableContacts = results?.saved === false
        ? contacts.filter(contact => contact.saved !== true) // If saved is false, filter
        : contacts; // Otherwise, use all contacts

    // Conditionally define selectableDisplayedContacts using ternary operator
    const selectableDisplayedContacts = results?.saved === false
        ? displayedContacts.filter(contact => contact.saved !== true) // If saved is false, filter
        : displayedContacts; // Otherwise, use all displayed contacts

    // Compute whether all *selectable* contacts are selected (using the variables defined above)
    const allContactsSelected =
        selectableContacts.length > 0 &&
        selectableContacts.every((contact) =>
            selectedContacts.includes(contact.contact_id)
        );

    // Compute whether all *selectable displayed* contacts are selected (using the variables defined above)
    const allDisplayedSelected =
        selectableDisplayedContacts.length > 0 &&
        selectableDisplayedContacts.every((contact) =>
            selectedContacts.includes(contact.contact_id)
        );

    // Handler for "Select All Contacts" checkbox
    const handleSelectAllChange = (e) => {
        onSelectAll(e.target.checked);
    };

    // Handler for "Select Displayed Contacts" checkbox
    const handleSelectDisplayedChange = (e) => {
        onSelectPage(displayedContacts, e.target.checked);
    };

    const formatResultsCount = (count, contactsLength) => {
        // console.log("Count:", count);
        // console.log("Contacts Length:", contactsLength);
        if (count > 0) {
            if (contactsLength < 2500) {
                return contactsLength.toString();
            } else {
                if (count > 1000000) {
                    return (count/1000000).toFixed(1) + "M";
                } else if (count > 1000) {
                    return (count/1000).toFixed(1) + "K";
                }
                return `${count.toString()}+`;
            }
        }
    }

    return (
        <div className={styles.resultsHeader}>
            {/* <input type="checkbox" onChange={toggleDropdown} /> */}
            <div className={styles.header}>Results ({formatResultsCount(results.totalCount, results.contacts.length)})</div>
            <label className={styles.selectors}>
                <input
                type="checkbox"
                checked={allContactsSelected}
                onChange={handleSelectAllChange}
                className={resultsBoxStyles.searchCheckbox}
                />
                <div>Select All</div>
            </label>
            <label className={styles.selectors}>
                <input
                type="checkbox"
                checked={allDisplayedSelected}
                onChange={handleSelectDisplayedChange}
                className={resultsBoxStyles.searchCheckbox}
                />
                <div>Select Page</div>
            </label>

            {selectedContacts.length > 0 && (
            <div className={styles.actions}>
                {results?.saved === false ? (
                    <div className={`${styles.saveChip} ${styles.pulsatingBorder}`} 
                        onClick={() => setIsSaveModalVisible(true)}>
                        + Save contacts
                    </div>
                ) : (
                    <div className={`${styles.saveChip} ${styles.pulsatingBorder}`} 
                        onClick={() => handleExport(selectedContacts)}>
                        + Export contacts
                    </div>
                )}
                
                <div className={styles.selectedChip} onClick={onClearSelected}>
                    <button className={styles.buttonX}>×</button> 
                    Selected contacts: {selectedContacts.length}
                </div>
            </div>
            )}
            {/* Conditionally render the modal */}
            {isSaveModalVisible && (
                <SaveContactsModal onClose={() => setIsSaveModalVisible(false)} selectedContacts={selectedContacts} />
            )}
            
        </div>
    );
};

export default ResultsHeader;
